export function parseServerDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;

  const s = String(value).trim();
  if (!s) return null;

  // Strip timezone suffix (Z or ±HH:mm) to treat timestamps as local time
  const normalized = s.replace(/([zZ]|[+-]\d{2}:\d{2})$/, "");

  // Parse "YYYY-MM-DD HH:mm:ss" or ISO "YYYY-MM-DDTHH:mm:ss(.SSS)" as local time
  const m = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?/
  );
  if (m) {
    const ms = m[7] ? Number(m[7].padEnd(3, "0")) : 0;
    const d = new Date(
      Number(m[1]),
      Number(m[2]) - 1,
      Number(m[3]),
      Number(m[4]),
      Number(m[5]),
      Number(m[6]),
      ms
    );
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatLocalDate(value, locale = "en-IN") {
  const d = parseServerDate(value);
  return d ? d.toLocaleDateString(locale) : "-";
}

export function formatLocalTime(value, locale = "en-IN") {
  const d = parseServerDate(value);
  return d ? d.toLocaleTimeString(locale) : "-";
}

export function formatLocalDateTime(value, locale = "en-IN") {
  const d = parseServerDate(value);
  return d ? d.toLocaleString(locale) : "-";
}
